import { z } from 'zod'

/**
 * Closed surface recipe identifiers. No free-form string escape (LAW closed schema).
 * Markers use kebab form (auth-1); IR uses Title-N form (Auth-1).
 */
export const SURFACE_RECIPE_IDS = [
  'Auth-1',
  'Shell-1',
  'ProTable-1',
  'Form-1',
  'Posture-1',
  'Page-1',
  'Detail-1',
  'Modal-1',
  'Feedback-1',
  'Chat-1',
  'Solo-1',
  'Signup-1',
  'Download-1',
  'Embed-1',
] as const

export type SurfaceRecipeId = (typeof SURFACE_RECIPE_IDS)[number]

export const SurfaceRecipeSchema = z.enum(SURFACE_RECIPE_IDS)

/** DOM data-vjal-recipe marker for a closed recipe id. */
export function recipeMarker(id: SurfaceRecipeId): string {
  return id
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([A-Za-z])(\d)/g, '$1-$2')
    .toLowerCase()
}
